import { useTranslation } from "react-i18next";
import { LanguageToggle } from "./LanguageToggle";
import { UtcClock } from "./UtcClock";

/** Every candidate page ends with the HR-thread line (decision 11). */
export function Footer({ showHr = true, compact = false }: { showHr?: boolean; compact?: boolean }) {
  const { t } = useTranslation();
  return (
    <footer className="mt-auto shrink-0 border-t border-line">
      <div
        className={`mx-auto flex w-full flex-col gap-3 text-xs text-ink-3 sm:flex-row sm:items-center sm:justify-between ${compact ? "px-5 py-2 sm:px-8" : "max-w-5xl px-4 py-5 sm:px-6"}`}
      >
        <p className="text-ink-2">{showHr ? t("footer.hrThread") : "SHEN NONG SHI"}</p>
        <div className="flex flex-wrap items-center gap-4">
          <a
            href="/agreement"
            target="_blank"
            rel="noopener noreferrer"
            className="text-link hover:underline"
          >
            {t("consent.title", { ns: "candidate" })}
          </a>
          <UtcClock />
          <LanguageToggle />
        </div>
      </div>
    </footer>
  );
}
